import React, {useEffect} from 'react';
import Grid from "@material-ui/core/Grid";
import {StyledSmallButton} from "../../ui-base/small-button";
import {ProposalModel} from "../../../models/proposal.model";
import styled from "styled-components";
import {Colors} from "../../../theme/colors";
import {CustomLinearProgress} from "../../custom-linear-progress/custom-linear-progress";
import emptyPublisherLogo from "../../../img/empty-publisher-logo.png";
import {Tooltip} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {BaseService} from "../../../services/base.service";
import {PublisherDetailsDialog} from "../../shared/publisher-details-dialog";

export const ApplicationToSend: React.FC<{
    proposal: ProposalModel,
    submitToPublisher?: any,
    confirmPublisher?: any,
    declinePublisher?: any,
    style?: any
}> = ({proposal, submitToPublisher, confirmPublisher, declinePublisher, style}) => {
    const [openPublisherDetails, setOpenPublisherDetails] = React.useState(false);
    const [statusClass, setStatusClass] = React.useState('');
    const {t} = useTranslation(['author', 'common']);

    useEffect(() => {
        if (proposal.matching > 0.66) {
            setStatusClass('green');
        }

        if (proposal.matching > 0.33 && proposal.matching <= 0.66) {
            setStatusClass('yellow');
        }

        if (proposal.matching <= 0.33) {
            setStatusClass('red');
        }
    }, [proposal.matching]);

    const getMatching = (matching: number) => {
        if (matching <= 0.33) {
            return t('common:poor');
        }

        if (matching > 0.33 && matching <= 0.66) {
            return t('common:medium');
        }

        if (matching > 0.66) {
            return t('common:veryGood');
        }
    }

    return (
        <Grid className="book-publisher" item container xs={12} sm={6} md={6} lg={3} direction={"column"}
              style={{...style, marginBottom: '1rem'}}>
            <StyledGrid item container direction={"column"}>
                {proposal?.matching !== null && proposal?.matching >= 0 &&
                    <Grid item container direction={"column"} spacing={1}>
                        <Grid item container direction={"row"} justifyContent={"space-between"}>
                            <Grid item>
                                <StyledP>{t('applicationToSend.fit')}</StyledP>
                            </Grid>

                            <Grid item>
                                {/*<StyledStatus className={statusClass}>{getMatching(proposal.matching)}</StyledStatus>*/}
                            </Grid>
                        </Grid>

                        <Grid item>
                            <CustomLinearProgress value={BaseService.getMatchingValue(proposal.matching)}/>
                        </Grid>
                    </Grid>
                }

                <Grid item container alignContent={"center"} direction={"column"} style={{flexGrow: 1}}>
                    <StyledH6 onClick={() => setOpenPublisherDetails(true)} style={{cursor: 'pointer'}}>
                        {proposal.publisher.name}
                    </StyledH6>
                    <StyledImg onClick={() => setOpenPublisherDetails(true)} style={{cursor: 'pointer'}}
                               src={proposal.publisher.logo?.file || emptyPublisherLogo} alt=""/>
                    <PublisherDetailsDialog open={openPublisherDetails} publisherId={proposal.publisher.id}
                                            showContactData={false}
                                            handleClose={() => {
                                                setOpenPublisherDetails(false)
                                            }}/>
                </Grid>

                <Grid item container direction={"row"} justifyContent={"center"}>
                    {confirmPublisher &&
                        <>
                            <StyledSmallButton type={"button"} onClick={() => {
                                declinePublisher(proposal.id)
                            }} color={"red"}
                                               style={{margin: '0 5px 0'}}>{t('applicationToSend.decline')}</StyledSmallButton>
                            <StyledSmallButton type={"button"} onClick={() => {
                                confirmPublisher(proposal.id)
                            }} color={"violet"}>{t('applicationToSend.accept')}</StyledSmallButton>
                        </>
                    }

                    {submitToPublisher &&
                        <Tooltip
                            title={proposal.publisher.publisher_type === 'ACTIVE' ? t('applicationToSend.activePubInfo') : t('applicationToSend.inactivePubInfo')}>
                            <div>
                                <StyledSmallButton type={"button"} onClick={() => {
                                    submitToPublisher(proposal.id)
                                }} color={"violet"}>
                                    {proposal.publisher.publisher_type === 'ACTIVE' ? t('applicationToSend.send') : t('applicationToSend.wantToSend')}
                                </StyledSmallButton>
                            </div>
                        </Tooltip>
                    }

                </Grid>
            </StyledGrid>
        </Grid>
    );
}

const StyledGrid = styled(Grid)`
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 1rem;
  height: 100%;
`;

const StyledImg = styled('img')`
  height: 135px;
  width: auto;
  margin: 1rem 0;
  object-fit: contain;
  //cursor: pointer;
`;

const StyledH6 = styled('h6')`
  font-size: 1rem;
  text-align: center;
  color: ${Colors.violet};
  margin: 1rem 0 0;
  cursor: pointer;
`;

const StyledP = styled('p')`
  font-size: 0.8rem;
  font-weight: 500;
`;

const StyledStatus = styled('p')`
  border: 1px solid #ccc;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 10px;
  padding: 2px 5px;

  &.green {
    color: ${Colors.green};
    border-color: ${Colors.lightGreen};
    background-color: ${Colors.extraLightGreen};
  }

  &.yellow {
    color: ${Colors.yellow};
    border-color: ${Colors.lightYellow};
    background-color: ${Colors.extraLightYellow};
  }

  &.red {
    color: ${Colors.dangerRed};
    border-color: ${Colors.lightRed};
    background-color: ${Colors.extraLightRed};
  }
`;
